import React from "react";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";

export default function Contact() {
  return (
    <div className="min-h-screen flex flex-col font-sans bg-gray-50">
      
      {/* Page Header Banner */}
      <header className="bg-slate-900 pt-12 pb-20 border-b-4 border-yellow-400">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link 
            to="/" 
            className="inline-flex items-center text-yellow-400 hover:text-yellow-300 mb-6 font-medium transition-colors"
          >
            <svg className="w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            Back to Home
          </Link>
          <h1 className="text-3xl md:text-5xl font-extrabold text-white tracking-tight">
            Get In Touch With Us
          </h1>
          <p className="mt-4 text-lg text-gray-300 max-w-2xl">
            Have questions about the Stolen Vehicle Report Portal? Reach out to the Central Motor Registry (CMR) Command Centre.
          </p>
        </div>
      </header>

      {/* Main Content Area */}
      <main className="flex-grow max-w-6xl mx-auto w-full px-4 sm:px-6 lg:px-8 -mt-10 mb-16 relative z-10">
        <div className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden flex flex-col lg:flex-row">
          
          {/* Left Column: Contact Form */}
          <div className="p-6 sm:p-10 lg:w-3/5">
            <h3 className="text-2xl font-bold text-slate-900 mb-6">Send a Message</h3>
            <form className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">Full Name</label>
                  <input type="text" id="name" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-colors" placeholder="John Doe" />
                </div>
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">Email Address</label>
                  <input type="email" id="email" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-colors" placeholder="john@example.com" />
                </div>
              </div>
              <div>
                <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-1">Subject</label>
                <input type="text" id="subject" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-colors" placeholder="How can we help you?" />
              </div>
              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">Message</label>
                <textarea id="message" rows="5" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-colors resize-none" placeholder="Type your message here..."></textarea>
              </div>
              <button type="submit" className="w-full sm:w-auto px-8 py-3 bg-slate-900 text-white font-bold rounded-lg hover:bg-slate-800 transition-colors focus:ring-4 focus:ring-slate-900/30">
                Send Message
              </button>
            </form>
          </div>

          {/* Right Column: Contact Information */}
          <div className="bg-slate-50 p-6 sm:p-10 lg:w-2/5 border-t lg:border-t-0 lg:border-l border-gray-200">
            <h3 className="text-2xl font-bold text-slate-900 mb-6">Contact Details</h3>
            
            <div className="space-y-8">
              {/* Address Block */}
              <div className="flex items-start">
                <div className="flex-shrink-0 mt-1">
                  <div className="w-10 h-10 bg-yellow-100 rounded-full flex items-center justify-center">
                    <svg className="w-5 h-5 text-yellow-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4">
                  <h4 className="text-lg font-semibold text-gray-900">Abuja Headquarters</h4>
                  <div className="mt-2 text-gray-600 leading-relaxed">
                    <p className="font-medium text-slate-800">The Nigeria Police Force</p>
                    <p>Central Motor Registry (CMR) Command Centre</p>
                    <p>Force Headquarters</p>
                    <p>Louis Edet House, Shehu Shagari Way</p>
                    <p>Abuja, FCT.</p>
                  </div>
                </div>
              </div>

              {/* Support Notice */}
              <div className="bg-blue-50 rounded-lg p-5 border border-blue-100">
                <h4 className="text-sm font-bold text-blue-900 uppercase tracking-wider mb-2">Need Immediate Help?</h4>
                <p className="text-sm text-blue-800">
                  If you are reporting a theft that just occurred, please contact your nearest local police division immediately or dial emergency lines before using this portal.
                </p>
              </div>
            </div>
          </div>
          
        </div>
      </main>

      <Footer />
    </div>
  );
}